import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { Table, Button, Popconfirm, DatePicker, Divider } from 'antd';
import { DeleteOutlined } from '@ant-design/icons';
import './styles.css';

const { Column } = Table;
const { RangePicker } = DatePicker;

const days = {
    'monday': 'Lunes',
    'tuesday': 'Martes',
    'wednesday': 'Miércoles',
    'thursday': 'Jueves',
    'friday': 'Viernes',
    'saturday': 'Sábado',
    'sunday': 'Domingo'
}

const PromotionsPerDayTable = ({ data, onDeletePromotion }) => {
    return (
        <Table className="promotionsPerDayTableCont" dataSource={data} rowKey="position" size="middle" pagination={false}>
            <Column title="Día" dataIndex="day" key="day" align="center"
            render={(text, record) => {
                return days[record.day];
            }}/>
            <Column title="Descuento (%)" dataIndex="discount" key="discount" align="center" />
            <Column title="Vigencia - Fechas" dataIndex="dateSince" key="dateSince" align="center" 
            render={(text, record) => {
                return (
                    <RangePicker format={'DD/MM/YYYY'} disabled
                    defaultValue={[moment(record.dateSince, 'DD/MM/YYYY'), moment(record.dateTo, 'DD/MM/YYYY')]}
                    disabledDate={(current) => {
                        let customDate = moment(new Date()).format("YYYY-MM-DD");
                        return current && current < moment(customDate, "YYYY-MM-DD");
                        }}/>
                    );
            }}/>
            <Column title="Vigencia - Horas" dataIndex="hourSince" key="hourSince" align="center" 
            render={(text, record) => {
                return (
                    <div>
                        {record.hourSince} <Divider type="vertical" /> {record.hourTo}
                    </div>
                );
            }}/>
            <Column title="" dataIndex="delete" key="delete" align="center"
                render={(text, record) => (
                    <span>
                        {
                            record.isLoading ?
                                <Button type="primary" disabled={true} loading>
                                    Cargando
                                </Button>
                                :
                                <Popconfirm title="¿Desea borrar la promoción?" okText="SI" cancelText="NO" onConfirm={() => onDeletePromotion(record)}>
                                    <Button><DeleteOutlined /></Button>
                                </Popconfirm>
                        }
                    </span>
                )}
            />
        </Table>
    );
};

PromotionsPerDayTable.propTypes = {
    data: PropTypes.array,
    onActionSelected: PropTypes.func,
};

export default PromotionsPerDayTable;